import React, { useState } from "react";
import { db } from "./firebase";
import { ref, get, child } from "firebase/database";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

function App() {
  const [fact, setFact] = useState("Click the button to see a fun fact!");
  const [savedFacts, setSavedFacts] = useState([]);
  const [category, setCategory] = useState("all");

  const fetchFactsFromFirebase = async (category) => {
    try {
      const dbRef = ref(db);
      const snapshot = await get(child(dbRef, `facts/${category}`));

      if (snapshot.exists()) {
        const factsArray = snapshot.val();
        return factsArray;
      } else {
        console.log("No data available for the selected category.");
        return [];
      }
    } catch (error) {
      console.error("Error fetching data from Firebase:", error);
      return [];
    }
  };

  const fetchRandomFactFromAPI = () => {
    fetch("https://uselessfacts.jsph.pl/random.json?language=en")
      .then((response) => response.json())
      .then((data) => {
        setFact(data.text);
      })
      .catch((error) => {
        setFact("Sorry, something went wrong.");
        console.error(error);
      });
  };

  const generateFact = async () => {
    if (category === "all") {
      fetchRandomFactFromAPI();
    } else {
      const factsArray = await fetchFactsFromFirebase(category);
      if (factsArray.length > 0) {
        const randomFact = factsArray[Math.floor(Math.random() * factsArray.length)];
        setFact(randomFact);
      } else {
        setFact("No facts available for this category.");
      }
    }
  };

  const saveFact = () => {
    if (fact !== "Click the button to see a fun fact!" && fact && !savedFacts.includes(fact)) {
      setSavedFacts([...savedFacts, fact]);
    } else if (savedFacts.includes(fact)) {
      alert("Fact is already saved!");
    }
  };

  const deleteFact = (index) => {
    const newSavedFacts = savedFacts.filter((_, i) => i !== index);
    setSavedFacts(newSavedFacts);
  };

  return (
    <div className="App">
      <div className="container">
        <h1>
          <img
            src="/logo512.png"
            alt="FactVerse Logo"
            className="logo"
          />
          FactVerse
        </h1>

        <div className="category-select">
          <label htmlFor="category" className="category-label">
            Select Category
          </label>
          <select
            className="form-control"
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="all">All</option>
            <option value="science">Science</option>
            <option value="universe">Universe</option>
            <option value="history">History</option>
            <option value="tech">Technology</option>
          </select>
        </div>

        <div className="fact-card">
          <p id="fun-fact">{fact}</p>
        </div>

        <div className="button-group">
          <button
            className="btn btn-primary"
            onClick={generateFact}
          >
            Generate Fact
          </button>
          <button
            className="btn btn-secondary"
            onClick={saveFact}
          >
            Save to Favorites
          </button>
        </div>

        <div className="saved-facts-container">
          <div className="saved-facts-title">
            📋 Saved Facts
          </div>
          <ul id="saved-facts-list">
            {savedFacts.map((fact, index) => (
              <li className="fact-item" key={index}>
                <span>{fact}</span>
                <button
                  className="delete-btn"
                  onClick={() => deleteFact(index)}
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <footer className="footer">
        <p>Made with ❤️ by <strong>Prince Mishra</strong></p>
      </footer>
    </div>
  );
}

export default App;